<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar
        :color="getToolbarColor()"
        :class="{
          '-not-fixed':
            Object.keys(selectedCondition).length > 0 ||
            !showPaintype ||
            (showPaintype && !isCategory) ||
            (isDentist && isDentistSearch),
          '-primary': getToolbarColor() === 'primary',
        }"
      >
        <ion-buttons slot="start">
          <ion-button
            v-if="
              showPaintype ||
              (Object.keys(selectedCondition).length > 0 && progress === 0)
            "
            @click="shouldGoBack()"
          >
            <ion-icon
              :src="require('@lib/assets/icons/icon_zurueck.svg')"
              slot="icon-only"
            ></ion-icon>
          </ion-button>
        </ion-buttons>
        <!-- <ion-buttons slot="end"> -->
        <ion-button
          v-if="
            !showPaintype &&
            !isCategory &&
            Object.keys(selectedCondition).length === 0 &&
            $store.getters.conversationsMessageCount.count
          "
          slot="end"
          fill="clear"
          class="ion-no-padding c-notification"
          :router-link="{ name: 'nachrichten' }"
        >
          <ion-icon
            :src="require('@lib/assets/icons/notifications.svg')"
            size="large"
          ></ion-icon>
          <div class="c-badge" style="position: absolute; top: 0; right: -6px">
            {{ $store.getters.conversationsMessageCount.count }}
          </div>
        </ion-button>
        <ion-button
          slot="end"
          fill="clear"
          @click="$store.commit('setOpenMenu', true)"
        >
          <ion-icon
            slot="icon-only"
            :src="require('@lib/assets/icons/menu.svg')"
            size="large"
          >
          </ion-icon
        ></ion-button>
        <!-- </ion-buttons> -->
      </ion-toolbar>
      <ion-toolbar
        v-if="
          Object.keys(selectedCondition).length > 0 &&
          (progress < 1 ||
            selectedCondition.type === 'pain' ||
            (progress === 1 && !shouldOpenInteliwiseModal))
        "
        :class="{ '-not-fixed': Object.keys(selectedCondition).length > 0 }"
      >
        <ion-buttons slot="end">
          <ion-button @click="shouldStepBack = true">
            Vorherige Antwort
            <ion-icon slot="end" :icon="chevronUp"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content" class="c-home__content">
      <div ref="scrollElement" class="ion-padding" style="height: 100%">
        <div
          v-if="!showPaintype && Object.keys(selectedCondition).length === 0"
          style="padding-bottom: 80px"
        >
          <div class="c-dashboard-box ion-padding">
            <ion-grid fixed>
              <ion-row>
                <ion-col size="12" size-sm="8" size-lg="10">
                  <div class="u-xlarge" style="margin-bottom: 0">
                    <ion-text color="primary"
                      ><b
                        >Hallo<template
                          v-if="$store.state.user.Initials === 'F'"
                        >
                          Frau</template
                        ><template
                          v-else-if="$store.state.user.Initials === 'M'"
                        >
                          Herr</template
                        ><template v-if="$store.state.user.LastName">
                          {{ " " + $store.state.user.LastName }}</template
                        >,</b
                      ></ion-text
                    >
                  </div>
                  <ion-row>
                    <ion-col>
                      <ion-text class="u-xxlarge u-line-normal" color="primary"
                        >wie können<br />wir Ihnen<br />helfen?</ion-text
                      >
                    </ion-col>
                    <ion-col size="auto" class="ion-text-right ion-hide-sm-up">
                      <img src="@/assets/img/home.svg" />
                    </ion-col>
                  </ion-row>
                  <ion-button
                    mode="ios"
                    class="c-dashboard-box__button ion-margin-top"
                    expand="block"
                    @click="
                      openShowPaintype(() => {
                        if (livechatOnline) {
                          openInteliwiseModal();
                        } else {
                          isDentist = false;
                          showPaintype = true;
                        }
                      })
                    "
                    ref="roodieCheckButton"
                  >
                    <ion-grid class="ion-no-padding">
                      <ion-row class="ion-align-items-center">
                        <ion-col class="ion-text-left">
                          <div class="c-typewriter">
                            <ion-note mode="ios" class="c-typewriter__text"
                              >Starten Sie den Roodie.Check …</ion-note
                            >
                          </div>
                        </ion-col>
                        <ion-col size="auto">
                          <ion-icon
                            :src="
                              require('@lib/assets/icons/roodie-app_icon.svg')
                            "
                            style="font-size: 24px"
                          />
                        </ion-col>
                      </ion-row>
                    </ion-grid>
                  </ion-button>
                </ion-col>
                <ion-col class="ion-text-right ion-hide-sm-down">
                  <img style="height: 100%" src="@/assets/img/home.svg" />
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
          <ion-grid fixed class="c-dashboard">
            <h2 class="c-dashboard__headline">
              <ion-icon :src="require('@lib/assets/icons/heartplus.svg')" />
              <ion-text color="primary"> Ich suche eine/n</ion-text>
            </h2>
            <ion-slides
              class="c-nugget-slider -span"
              :options="nuggetSlideOpts"
              ref="searchSlider"
              @ionSlidesDidLoad="$refs.searchSlider?.$el.update()"
            >
              <ion-slide>
                <div
                  @click="
                    if (livechatOnline) {
                      openInteliwiseModal();
                    } else {
                      isSpecialist = true;
                      showPaintype = true;
                      content.$el.scrollToTop();
                    }
                  "
                  class="c-nugget"
                >
                  <div
                    class="c-nugget__image u-bg-green"
                    :style="{
                      'background-image':
                        'url(' +
                        require('@/assets/img/home/icon_facharzt_iso.svg') +
                        ')',
                    }"
                  ></div>
                  <div
                    class="c-nugget__label"
                    v-html="nameMap.doctorsearch.name"
                  ></div>
                </div>
              </ion-slide>
              <ion-slide>
                <div
                  @click="
                    isSecondOpinion = true;
                    showPaintype = true;
                    content.$el.scrollToTop();
                  "
                  class="c-nugget"
                >
                  <div
                    class="c-nugget__image u-bg-blue"
                    :style="{
                      'background-image':
                        'url(' +
                        require('@/assets/img/home/icon_zweitmeinung_iso.svg') +
                        ')',
                    }"
                  ></div>
                  <div class="c-nugget__label">
                    {{ nameMap.secondopinion.name }}
                  </div>
                </div>
              </ion-slide>
              <ion-slide>
                <div
                  @click="
                    isDentist = true;
                    showPaintype = true;
                    showDentistIntroScreen = true;
                    content.$el.scrollToTop();
                  "
                  class="c-nugget"
                >
                  <div
                    class="c-nugget__image u-bg-orange"
                    :style="{
                      'background-image':
                        'url(' +
                        require('@/assets/img/home/icon_zahnarzt_iso.svg') +
                        ')',
                    }"
                  ></div>
                  <div
                    class="c-nugget__label"
                    v-html="nameMap.expertsearch"
                  ></div>
                </div>
              </ion-slide>
              <ion-slide>
                <div @click="$router.push('/coaching')" class="c-nugget">
                  <div
                    class="c-nugget__image u-bg-yellow"
                    :style="{
                      'background-image':
                        'url(' +
                        require('@/assets/img/home/icon_coaching_herz_iso.svg') +
                        ')',
                    }"
                  ></div>
                  <div class="c-nugget__label">
                    {{ nameMap.coaching }}
                  </div>
                </div>
              </ion-slide>
              <ion-slide>
                <div @click="$router.push({ path: '/arag' })" class="c-nugget">
                  <div
                    class="c-nugget__image u-bg-yellow"
                    :style="{
                      'background-image':
                        'url(' + require('@/assets/img/slider/arag.svg') + ')',
                    }"
                  ></div>
                  <div class="c-nugget__label" v-html="nameMap.arag"></div>
                </div>
              </ion-slide>
            </ion-slides>

            <h2 class="c-dashboard__headline">
              <ion-icon :src="require('@lib/assets/icons/heartplus.svg')" />
              <ion-text color="primary"> Auf einen Blick</ion-text>
            </h2>
            <ion-slides
              class="c-nugget-slider -span ion-margin-bottom"
              :options="nuggetSlideOpts"
              ref="linkSlider"
              @ionSlidesDidLoad="$refs.linkSlider?.$el.update()"
            >
              <ion-slide>
                <div class="c-nugget" @click="$router.push('/roodie-checks')">
                  <div
                    class="c-nugget__image"
                    :style="{
                      'background-image':
                        'url(' +
                        require('@/assets/img/slider/links/roodie-checks.svg') +
                        ')',
                    }"
                  ></div>
                  <div class="c-nugget__label">Roodie.Checks</div>
                </div>
              </ion-slide>
              <ion-slide>
                <div
                  class="c-nugget"
                  @click="$router.push({ name: 'termine-aerzte' })"
                >
                  <div
                    class="c-nugget__image"
                    :style="{
                      'background-image':
                        'url(' +
                        require('@/assets/img/slider/links/termine-aerzte.png') +
                        ')',
                    }"
                  ></div>
                  <div class="c-nugget__label">Termine & Ärzte</div>
                </div>
              </ion-slide>
              <ion-slide>
                <div
                  class="c-nugget"
                  @click="$router.push({ name: 'nachrichten' })"
                >
                  <div
                    class="c-nugget__image"
                    :style="{
                      'background-image':
                        'url(' + require('@/assets/img/slider/links/chat.png'),
                    }"
                  ></div>
                  <div class="c-nugget__label">Nachrichten</div>
                </div>
              </ion-slide>
              <ion-slide>
                <div
                  class="c-nugget"
                  @click="$router.push({ name: 'befunde' })"
                >
                  <div
                    class="c-nugget__image"
                    :style="{
                      'background-image':
                        'url(' +
                        require('@/assets/img/slider/links/befunde.svg'),
                    }"
                  ></div>
                  <div class="c-nugget__label">Befunde & Co</div>
                </div>
              </ion-slide>
              <ion-slide>
                <div
                  class="c-nugget"
                  @click="$router.push({ name: 'behandlungsplan-pruefen' })"
                >
                  <div
                    class="c-nugget__image"
                    :style="{
                      'background-image':
                        'url(' +
                        require('@/assets/img/slider/links/behandlungsplan/zahn-behandlungsplan-einreichen.svg'),
                    }"
                  ></div>
                  <div class="c-nugget__label">Behandlungs&shy;plan prüfen</div>
                </div>
              </ion-slide>
              <ion-slide>
                <div class="c-nugget" @click="openAragApp">
                  <div
                    class="c-nugget__image"
                    :style="{
                      'background-image':
                        'url(' +
                        require('@/assets/img/home/icon_rechnungen.svg') +
                        ')',
                    }"
                  ></div>
                  <div class="c-nugget__badge">
                    <img
                      width="30"
                      height="30"
                      src="@/assets/img/arag_logo.png"
                      alt="ARAG Logo"
                    />
                  </div>
                  <div class="c-nugget__label">Rechnungen einreichen</div>
                </div>
              </ion-slide>
              <!-- <ion-slide>
                <div class="c-nugget">
                  <div
                    class="c-nugget__image"
                    :style="{
                      'background-image':
                        'url(' +
                        require('@/assets/img/slider/links/polizzen.png') +
                        ')',
                    }"
                  ></div>
                  <div class="c-nugget__label">
                    Polizzen
                  </div>
                </div>
              </ion-slide> -->
            </ion-slides>
            <div class="-span -half-lg">
              <div
                class="c-nugget -cover -no-pointer -height-100 u-bold"
                :style="{
                  'background-image':
                    'url(' + require('@/assets/img/gradient_blau.svg') + ')',
                }"
              >
                <div class="c-nugget__content">
                  <div class="ion-padding-bottom">
                    Ich brauche Unterstützung bei der Arzt- oder Kliniksuche.*
                  </div>
                  <div class="c-nugget__buttons ion-margin-top">
                    <ion-button
                      @click="
                        $router.push({
                          name: 'betterdoc-kontakt',
                        })
                      "
                      class="u-small"
                      color="light"
                    >
                      <ion-icon
                        :src="require('@lib/assets/icons/icon_dok.svg')"
                        slot="start"
                      />
                      Anfrage starten</ion-button
                    >
                  </div>
                </div>
                <div class="u-small ion-margin-bottom">
                  *Ausführender Partner:
                  <a
                    href="#"
                    class="u-color-white"
                    @click.prevent="
                      $router.push({
                        name: 'betterdoc',
                        params: { from: 'contact' },
                      })
                    "
                    >BetterDoc GmbH</a
                  >
                </div>
              </div>
            </div>
            <div class="-span -half-lg">
              <div
                class="c-nugget -no-pointer -cover -height-100 u-bold"
                :style="{
                  'background-image':
                    'url(' + require('@/assets/img/gradient_gruen.svg') + ')',
                }"
              >
                <div class="c-nugget__content">
                  <div class="ion-padding-bottom">
                    Ich möchte per Video eine ärztliche Erstabklärung machen.*
                  </div>
                  <div class="c-nugget__buttons ion-margin-top">
                    <ion-button
                      @click="
                        $router.push({
                          name: 'medgate-kontakt',
                        })
                      "
                      class="u-small"
                      color="light"
                      ><ion-icon
                        :src="require('@lib/assets/icons/phone-video.svg')"
                        slot="start"
                      ></ion-icon
                      >Zum digitalen Arztbesuch</ion-button
                    >
                  </div>
                </div>
                <div class="u-small ion-margin-bottom ion-padding-horizontal">
                  *Ausführender Partner:
                  <a
                    href="#"
                    class="u-color-white"
                    @click.prevent="
                      $router.push({
                        name: 'medgate',
                        params: { from: 'contact' },
                      })
                    "
                    >Medgate Deutschland GmbH</a
                  >
                </div>
              </div>
            </div>

            <h2 class="c-dashboard__headline">
              <ion-icon :src="require('@lib/assets/icons/heartplus.svg')" />
              <ion-text color="primary"> Gut zu wissen</ion-text>
            </h2>
            <ion-slides
              class="c-nugget-slider -span"
              :options="infoSlideOpts"
              ref="infoSlider"
              @ionSlidesDidLoad="$refs.infoSlider?.$el.update()"
            >
              <ion-slide>
                <div
                  class="c-nugget -big"
                  @click="
                    $router.push({
                      name: 'zahn-ratgeber',
                    })
                  "
                >
                  <div
                    class="c-nugget__image"
                    :style="{
                      'background-image':
                        'url(' +
                        require('@/assets/img/header/icon_glossary.svg') +
                        ')',
                    }"
                  ></div>
                  <div class="c-nugget__label">
                    Ratgeber zur Zahnzusatzversicherung
                  </div>
                </div>
              </ion-slide>
              <ion-slide>
                <div
                  class="c-nugget -cover -top -big"
                  @click="
                    $router.push({
                      name: 'nachdergeburt',
                    })
                  "
                >
                  <div
                    class="c-nugget__image"
                    :style="{
                      'background-image':
                        'url(' +
                        require('@arag/assets/img/content/nach_der_geburt_mf.svg') +
                        ')',
                    }"
                  ></div>
                  <div class="c-nugget__label">
                    Nach der Geburt: 7 Schritte durch den Behördendschungel
                  </div>
                </div>
              </ion-slide>
            </ion-slides>

            <h2 class="c-dashboard__headline">
              <ion-icon :src="require('@lib/assets/icons/heartplus.svg')" />
              <ion-text color="primary"> Unsere Partner</ion-text>
            </h2>
            <ion-slides
              class="c-dashboard-slider -span"
              :pager="true"
              :options="slideOpts"
              ref="slider"
              @ionSlidesDidLoad="$refs.slider?.$el.update()"
            >
              <ion-slide
                class="c-dashboard-slide"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/slider/slider_betterdoc.svg') +
                    ')',
                }"
                @click="
                  $router.push({
                    name: 'betterdoc',
                    params: { from: 'contact' },
                  })
                "
              >
                <div class="c-dashboard-slide__logo">
                  <img src="@/assets/img/betterdoc_logo.svg" />
                </div>
                <div class="c-dashboard-slide__content">
                  <p>
                    <b>Unterstützung bei der Arzt-/Kliniksuche</b>
                  </p>
                  <p>
                    Egal, ob Sie einen Arzt oder eine Klinik suchen oder schon
                    in Behandlung sind, BetterDoc sucht nach dem bestmöglichen
                    Behandler für Sie.
                  </p>
                </div>
                <div class="c-dashboard-slide__image">
                  <img src="@/assets/img/slider/betterdoc.svg" />
                </div>
              </ion-slide>
              <ion-slide
                class="c-dashboard-slide"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/slider/slider_medgate.svg') +
                    ')',
                }"
                @click="
                  $router.push({
                    name: 'medgate',
                    params: { from: 'contact' },
                  })
                "
              >
                <div class="c-dashboard-slide__logo">
                  <img src="@/assets/img/medgate_logo.svg" />
                </div>
                <div class="c-dashboard-slide__content">
                  <p>
                    <b>Digitaler Arztbesuch – ohne Wartezeit.</b>
                  </p>
                  <p>
                    Probieren Sie den digitalen Arztbesuch aus. Eignet sich
                    besonders, wenn Sie gerade unterwegs sind oder Ihr Zuhause
                    aufgrund Ihrer Beschwerden nicht verlassen möchten.
                  </p>
                </div>
                <div class="c-dashboard-slide__image">
                  <img src="@/assets/img/slider/medgate.svg" />
                </div>
              </ion-slide>
              <ion-slide
                class="c-dashboard-slide"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/slider/slider_tagesklinik.svg') +
                    ')',
                  'background-position-x': '50%',
                }"
                @click="
                  $router.push({
                    name: 'zahnarzt-ztk',
                    params: { from: '' },
                  })
                "
              >
                <div class="c-dashboard-slide__logo" style="width: 210px">
                  <img src="@/assets/img/ztk_logo.svg" />
                </div>
                <div class="c-dashboard-slide__content">
                  <p>
                    <b>
                      Exklusiver und schneller Zugang zu den besten Zahnärzten
                      in Süd-Deutschland.
                    </b>
                  </p>
                  <p>
                    Zahnbehandlung, Implantologie, professionelle Zahnreinigung,
                    Zahnfüllungen und vieles mehr.
                  </p>
                </div>
                <div class="c-dashboard-slide__image">
                  <img src="@/assets/img/slider/tagesklinik.svg" />
                </div>
              </ion-slide>
              <ion-slide
                class="c-dashboard-slide"
                @click="
                  $router.push({
                    name: 'qualitysmile',
                  })
                "
              >
                <div class="c-dashboard-slide__logo">
                  <img src="@/assets/img/qualitysmile_logo.png" />
                </div>
                <div class="c-dashboard-slide__content">
                  <p>
                    <b>
                      Ihr Partner für Zahnversorgungen und Zahnersatz -
                      deutschlandweit
                    </b>
                  </p>
                </div>
                <div class="c-dashboard-slide__image">
                  <img src="@/assets/img/home/icon_zahnarzt_iso.svg" />
                </div>
              </ion-slide>
              <ion-slide
                class="c-dashboard-slide"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/slider/slider_medical_contact.svg') +
                    ')',
                  'background-position-x': '48%',
                }"
                @click="$router.push({ path: '/coaching' })"
              >
                <div class="c-dashboard-slide__logo" style="width: 180px">
                  <img src="@/assets/img/medicalcontact_logo.png" />
                </div>
                <div class="c-dashboard-slide__content">
                  <p>
                    <b>
                      Ihr Coaching bei Herzerkrankung oder Diabetes Typ II.
                    </b>
                  </p>
                  <p>
                    Tipps von Experten zu Ernährung, körperlicher Aktivität und
                    zur Vorbeugung von Folgeerkrankungen verhelfen zu besserer
                    Lebensqualität.
                  </p>
                </div>
                <div class="c-dashboard-slide__image">
                  <img src="@/assets/img/slider/medical_contact.svg" />
                </div>
              </ion-slide>
              <ion-slide
                class="c-dashboard-slide"
                @click="$router.push({ path: '/arag' })"
              >
                <div class="c-dashboard-slide__logo">
                  <img src="@/assets/img/arag_logo.png" />
                </div>
                <div class="c-dashboard-slide__content">
                  <p>
                    <b>
                      Persönliche Unterstützung bei Ihren Gesundheitsthemen
                    </b>
                  </p>
                  <p>
                    Die ARAG Gesundheitsassistenten nehmen sich individuell
                    Ihrem Anliegen an, kümmern sich um die bestmögliche Lösung
                    und übernehmen die Organisation für Sie.
                  </p>
                </div>
                <div class="c-dashboard-slide__image">
                  <img src="@/assets/img/slider/arag.svg" />
                </div>
              </ion-slide>
            </ion-slides>
            <branding class="u-color-primary" />
          </ion-grid>
        </div>
        <template v-else-if="showPaintype">
          <template v-if="isDentist">
            <ion-grid
              v-if="isDentistSearch"
              class="c-paintype"
              style="height: 100%"
              fixed
            >
              <ion-row
                class=""
                style="min-height: 100%; align-content: space-around"
              >
                <ion-col size="12">
                  <roodie :expression="'happy'" />
                  <h6>
                    <b>
                      {{ zahnBeschwerden["1"].text }}
                    </b>
                  </h6>
                  <tooltip :text="zahnBeschwerden['1'].info" />
                </ion-col>
                <ion-col>
                  <Buttons
                    :question="zahnBeschwerden['1']"
                    @done="
                      if ($event.value === 'Professionelle Zahnreinigung') {
                        partnerModalHeadline =
                          'Professionelle Zahnreinigung in Aufbau';
                        openPartnerModal($event.value);
                      } else if ($event.value === 'Vorsorgetermin') {
                        partnerModalHeadline =
                          'Ärzte für Zahnvorsorge in Aufbau';
                        openPartnerModal($event.value);
                      } else if ($event.value === 'Kosmetische Behandlung') {
                        selectedCondition = {
                          name: 'toothCosmetic',
                          area: 'head-front',
                          type: '',
                          part: '',
                          deepPart: '',
                        };
                        showPaintype = false;
                      } else if (
                        [
                          'Zahnersatz',
                          'Brauche einen Kieferorthopäden',
                        ].includes($event.value)
                      ) {
                        selectedCondition = {
                          name: 'toothJaw',
                          area: 'head-front',
                          value: $event.value,
                          type: '',
                          part: '',
                          deepPart: '',
                        };
                        showPaintype = false;
                      } else if ($event.value === 'Zweite Meinung einholen') {
                        selectedCondition = {
                          name: 'toothSecondopinion',
                          area: 'head-front',
                          type: '',
                          part: '',
                          deepPart: '',
                        };
                        showPaintype = false;
                      } else if (
                        $event.value === 'Prüfung meines Behandlungsplans'
                      ) {
                        selectedCondition = {
                          name: 'toothTreatmentplan',
                          area: 'head-front',
                          type: '',
                          part: '',
                          deepPart: '',
                        };
                        showPaintype = false;
                      } else {
                        selectedCondition = {
                          name: 'tooth',
                          value: $event.value,
                          area: 'head-front',
                          type: '',
                          part: '',
                          deepPart: '',
                        };
                        showPaintype = false;
                      }

                      if (
                        Object.keys(selectedCondition).length &&
                        $event.checkName
                      ) {
                        selectedCondition.checkName = $event.checkName;
                      }
                    "
                  />
                </ion-col>
              </ion-row>
              <!-- <ion-modal
                :is-open="showPartnerModal"
                :css-class="['c-autoheight-modal']"
                @didDismiss="showPartnerModal = false"
              >
                <ion-page
                  class="ion-padding ion-text-center u-color-primary u-bold"
                >
                  <modal-close />
                  <roodie fillOuter="#5E58BE" :expression="'happy'" />
                  <div class="u-large ion-margin-top">
                    {{ partnerModalHeadline }}
                  </div>
                  <p>
                    Mit den Zahnärztlichen Tageskliniken bieten wir in
                    Süd-Deutschland erstklassige Zahnärzte und ermöglichen Ihnen
                    eine direkte Abrechnung von Zahnarztrechnungen mit der ARAG.
                    Für andere Regionen in Deutschland können wir derzeit noch
                    keine Standorte anbieten.
                  </p>
                  <div class="u-medium ion-margin-vertical">
                    Danke für Ihr Verständnis!
                  </div>
                  <img
                    class="ion-margin-vertical"
                    src="@/assets/img/slider/tagesklinik.svg"
                    width="130"
                  />
                  <div>
                    <ion-button
                      @click="
                        showPartnerModal = false;
                        selectedCondition = {
                          name: 'toothAppointment',
                          area: 'head-front',
                          type: '',
                          part: '',
                          deepPart: '',
                        };
                        showPaintype = false;
                      "
                      fill="outline"
                      >Termin buchen in S-Deutschland</ion-button
                    >
                  </div>
                  <div>
                    <ion-button
                      @click="
                        showPartnerModal = false;
                        openEndModal('ZTK');
                      "
                      fill="outline"
                      >Weiter</ion-button
                    >
                  </div>
                </ion-page>
              </ion-modal> -->
            </ion-grid>
            <ion-grid v-else fixed>
              <Header
                class="u-bg-orange -contain"
                headline="Ihr Lachen ist unser Anliegen."
                :image="require('@/assets/img/header/icon_zahnarzt.svg')"
                @openChat="isDentistSearch = true"
              />
              <p class="ion-padding-top">
                <b
                  >Sie haben Zahnbeschwerden oder suchen einen neuen Zahnarzt?
                </b>
              </p>
              <p>
                Wir unterstützen Sie bei der Organisation Ihrer Zahnbehandlung.
                Dafür bieten wir Ihnen verschiedene hilfreiche Services:
              </p>
              <ul>
                <li>Vermittlung von Ärzten für eine Zweitmeinung</li>
                <li>
                  Direktabrechnung mit ausgewählten Zahnärzten: Sie müssen nicht
                  in Vorleistung gehen, die Leistungen werden direkt mit der
                  ARAG abgerechnet
                </li>
                <li>Alternativer Kostenvoranschlag bei Zahnersatz</li>
                <li>Organisation und Begleitung einer Zahnbehandlung</li>
              </ul>
              <div class="u-color-primary">
                <ion-icon
                  :src="require('@lib/assets/icons/info.svg')"
                />&nbsp;<b>Hinweis:</b>
                <div>
                  Wir helfen Ihnen gezielt und individuell bei Ihren
                  gesundheitlichen Anliegen. Wir führen daher keine herkömmliche
                  Zahnarztsuche durch, wie Sie sie von Suchmaschinen kennen.
                </div>
              </div>
              <div class="c-cta">
                <ion-button @click="isDentistSearch = true" class="mt-5"
                  >Jetzt Zahnarzt suchen&nbsp;
                  <ion-icon
                    :src="require('@lib/assets/icons/roodie-white.svg')"
                    slot="end"
                  ></ion-icon>
                </ion-button>
              </div>
            </ion-grid>
          </template>
          <template v-else-if="isSpecialist">
            <ion-grid fixed>
              <Header
                class="u-bg-green -contain"
                headline="Der schnellste Weg zu Fachärzten/Spezialisten."
                :image="require('@/assets/img/header/icon_facharzt.svg')"
                @openChat="
                  selectedCondition = {
                    name: 'doctorsearch',
                    area: 'body-front',
                    type: '',
                    part: '',
                    deepPart: '',
                  };
                  showPaintype = false;
                "
              />
              <p class="ion-padding-top">
                Überlassen Sie die Suche nach der bestmöglichen Behandlung nicht
                Suchmaschinen im Netz, sondern medizinisch ausgebildetem
                Fachpersonal.
              </p>
              <p>
                So bleiben Sie gesund oder kommen schnell zur richtigen Diagnose
                und erhöhen Ihre Heilungschancen. Ganz nach Ihrem Wunsch:
                persönlich vor Ort, bequem per Video oder schnell per Telefon.
              </p>
              <div class="c-list-grid">
                <p>
                  <ion-row>
                    <ion-col size="auto">
                      <ion-icon
                        size="large"
                        :src="
                          require('@lib/assets/icons/icon_erstdiagnose.svg')
                        "
                      />
                    </ion-col>
                    <ion-col> Erstdiagnose </ion-col>
                  </ion-row>
                </p>
                <p>
                  <ion-row>
                    <ion-col size="auto">
                      <ion-icon
                        size="large"
                        :src="
                          require('@lib/assets/icons/icon_vorsorgeuntersuchung.svg')
                        "
                      />
                    </ion-col>
                    <ion-col> Vorsorgeuntersuchung </ion-col>
                  </ion-row>
                </p>
                <p>
                  <ion-row>
                    <ion-col size="auto">
                      <ion-icon
                        size="large"
                        :src="
                          require('@lib/assets/icons/icon_verlaufskontrolle.svg')
                        "
                      />
                    </ion-col>
                    <ion-col> Verlaufskontrolle </ion-col>
                  </ion-row>
                </p>
                <p>
                  <ion-row>
                    <ion-col size="auto">
                      <ion-icon
                        size="large"
                        :src="
                          require('@lib/assets/icons/icon_weiter_behandlung.svg')
                        "
                      />
                    </ion-col>
                    <ion-col> Weiterbehandlung </ion-col>
                  </ion-row>
                </p>
                <p>
                  <ion-row>
                    <ion-col size="auto">
                      <ion-icon
                        size="large"
                        :src="require('@lib/assets/icons/icon_artzwechsel.svg')"
                      />
                    </ion-col>
                    <ion-col> Arztwechsel </ion-col>
                  </ion-row>
                </p>
                <p>
                  <ion-row>
                    <ion-col size="auto">
                      <ion-icon
                        size="large"
                        :src="require('@lib/assets/icons/icon_operateur.svg')"
                      />
                    </ion-col>
                    <ion-col> Operateur </ion-col>
                  </ion-row>
                </p>
              </div>
              <p>
                Machen Sie den Roodie.Check und beantworten Sie ein paar Fragen
                zu Ihrem gesundheitlichen Anliegen, um Ihnen gezielt helfen zu
                können.
              </p>
              <div class="c-cta">
                <ion-button
                  @click="
                    selectedCondition = {
                      name: 'doctorsearch',
                      area: 'body-front',
                      type: '',
                      part: '',
                      deepPart: '',
                    };
                    showPaintype = false;
                  "
                  class="mt-5"
                  >Jetzt Facharzt/Klinik suchen&nbsp;
                  <ion-icon
                    :src="require('@lib/assets/icons/roodie-white.svg')"
                    slot="end"
                  ></ion-icon>
                </ion-button>
              </div>
            </ion-grid>
          </template>
          <template v-else-if="isSecondOpinion">
            <ion-grid fixed>
              <Header
                class="u-bg-blue -contain"
                headline="Zweite Meinung gibt ein sicheres Gefühl."
                :image="require('@/assets/img/header/icon_facharzt.svg')"
                @openChat="
                  selectedCondition = {
                    name: 'secondopinion',
                    area: 'body-front',
                    type: '',
                    part: '',
                    deepPart: '',
                  };
                  showPaintype = false;
                "
              />
              <p class="ion-padding-top ion-hide-lg-up">
                <b>Zweite Meinung gibt ein sicheres Gefühl.</b>
              </p>
              <p>
                Bei Zweifeln an einer Diagnose oder Therapie- empfehlung kann
                die zweite Meinung eines Spezialisten sehr hilfreich sein. Oft
                gibt es mehrere Behandlungswege und insbesondere bei
                bevorstehenden Operationen, schweren Erkrankungen, wie Krebs,
                oder großen Zahnbehandlungen drängt sich die Frage nach einer
                Zweitmeinung auf.
              </p>
              <p>
                <b>Nehmen Sie Ihre Gesundheit selbst in die Hand.</b><br />
                Lassen Sie Ihre Diagnose und Behandlung von einem
                hochqualifizierten und unabhängigen Arzt überprüfen.
              </p>
              <p>
                Machen Sie den Roodie.Check und beantworten Sie ein paar Fragen,
                um Ihnen gezielt bei der Suche helfen zu können.
              </p>
              <div class="c-cta">
                <ion-button
                  @click="
                    selectedCondition = {
                      name: 'secondopinion',
                      area: 'body-front',
                      type: '',
                      part: '',
                      deepPart: '',
                    };
                    showPaintype = false;
                  "
                  class="mt-5"
                  >Jetzt Zweitmeinung einholen&nbsp;
                  <ion-icon
                    :src="require('@lib/assets/icons/roodie-white.svg')"
                    slot="end"
                  ></ion-icon>
                </ion-button>
              </div>
            </ion-grid>
          </template>
          <template v-else>
            <ion-grid class="c-paintype" style="height: 100%" fixed>
              <ion-row
                class=""
                style="min-height: 100%; align-content: space-around"
              >
                <ion-col size="12">
                  <roodie :expression="'happy'" />
                  <h6>
                    <b>
                      Sagen Sie uns, was Ihnen fehlt oder wo Sie Hilfe
                      benötigen:
                    </b>
                  </h6>
                  <tooltip
                    text="Wählen Sie bitte, was auf Sie zutrifft."
                    image="paintype.png"
                  />
                </ion-col>
                <ion-col class="ion-text-right">
                  <div>
                    <ion-button
                      @click="
                        openPainChat('pain');
                        trackChatAnswer(
                          'Ich habe Beschwerden/Schmerzen',
                          'Sagen Sie uns, was Ihnen fehlt oder wo Sie Hilfe benötigen:'
                        );
                      "
                      fill="outline"
                      class="ion-text-wrap"
                      >Ich habe Beschwerden/Schmerzen</ion-button
                    >
                  </div>
                  <div>
                    <ion-button
                      @click="
                        openPainChat('secondopinion');
                        trackChatAnswer(
                          'Ich möchte eine Zweitmeinung einholen',
                          'Sagen Sie uns, was Ihnen fehlt oder wo Sie Hilfe benötigen:'
                        );
                      "
                      fill="outline"
                      class="ion-text-wrap"
                      >Ich möchte eine Zweitmeinung einholen</ion-button
                    >
                  </div>
                  <div>
                    <ion-button
                      @click="
                        openPainChat('doctorswitch');
                        trackChatAnswer(
                          'Ich suche eine/n Facharzt/Klinik oder möchte meinen Arzt wechseln',
                          'Sagen Sie uns, was Ihnen fehlt oder wo Sie Hilfe benötigen:'
                        );
                      "
                      fill="outline"
                      class="ion-text-wrap"
                      >Ich suche eine/n Facharzt/Klinik oder möchte meinen Arzt
                      wechseln</ion-button
                    >
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
          </template>
        </template>
        <template v-else>
          <chat
            :selectedCondition="selectedCondition"
            :selectedSentence="selectedSentence"
            :person="person"
            :genderValue="genderValue"
            :shouldStepBack="shouldStepBack"
            :shouldOpenInteliwiseModal="shouldOpenInteliwiseModal"
            :scrollElement="scrollElement"
            @stepped-back="shouldStepBack = false"
            @back-to-search="shouldGoBackToSearch(false, $event)"
            @progress-change="progress = $event"
            @show-paintype="showPaintype = $event"
          />
        </template>
      </div>
      <add-fab
        v-if="!showPaintype && Object.keys(selectedCondition).length === 0"
      ></add-fab>
      <!-- <ion-fab
        v-if="progress === 1"
        vertical="bottom"
        horizontal="center"
        slot="fixed"
        :edge="true"
      >
        <ion-fab-button>
          <ion-icon :icon="add"></ion-icon>
        </ion-fab-button>
        <ion-fab-list side="top" class="ion-align-items-start">
          <ion-button
            ><ion-icon
              :src="require('@lib/assets/icons/print-circle-white.svg')"
              slot="start"
              size="large"
            />PDF erstellen</ion-button
          >
          <ion-button
            ><ion-icon
              :src="require('@lib/assets/icons/download-circle-white.svg')"
              slot="start"
              size="large"
            />Teilen</ion-button
          >
        </ion-fab-list>
      </ion-fab> -->
    </ion-content>
    <ion-footer
      class="ion-no-border"
      v-if="
        Object.keys(selectedCondition).length > 0 ||
        (showPaintype && !isCategory) ||
        (isDentist && isDentistSearch)
      "
    >
      <ion-toolbar
        :class="{ '-not-fixed': Object.keys(selectedCondition).length > 0 }"
      >
        <ion-buttons slot="start">
          <ion-button color="primary" @click="shouldGoBackToSearch(true)">
            <ion-icon
              :src="require('@lib/assets/icons/icon_home_2.svg')"
              slot="start"
            ></ion-icon>
          </ion-button>
        </ion-buttons>
        <div
          class="c-progress-bar"
          :style="{ width: 'calc(' + progress + ' * 100%)' }"
        ></div>
      </ion-toolbar>
    </ion-footer>

    <ion-popover
      :is-open="isPopoverOpen"
      css-class="c-tip-popover"
      :event="popoverEvent"
      @didDismiss="setPopoverOpen(false)"
      mode="ios"
    >
      <div class="ion-padding">
        <ion-grid>
          <ion-row>
            <ion-col size="auto">
              <ion-icon
                :icon="bulbOutline"
                color="primary"
                size="large"
              ></ion-icon>
            </ion-col>
            <ion-col>
              Tipp: Ein paar Fragen von Roodie beantworten und gezielt Hilfe
              bekommen.
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </ion-popover>

    <ion-modal
      :is-open="showBiometricSetupModal"
      :css-class="['c-autoheight-modal']"
      @didDismiss="showBiometricSetupModal = false"
    >
      <ion-page>
        <div class="ion-padding modal-content ion-text-center">
          <modal-close />
          <div class="ion-margin-bottom">
            <img v-if="isNativeBiometricFaceId" src="@/assets/img/faceid.svg" />
            <ion-icon
              v-else
              :icon="fingerPrintOutline"
              size="large"
              color="primary"
            ></ion-icon>
          </div>
          <b>Möchten Sie sich künftig schneller anmelden?</b>
          <p>
            Aktivieren Sie
            {{ isNativeBiometricFaceId ? "Face-ID" : "Touch-ID" }}.
          </p>
          <ion-button fill="outline" @click="setNativeBiometricCredentials"
            >{{
              isNativeBiometricFaceId ? "Face ID" : "Touch ID"
            }}
            aktivieren</ion-button
          >
          <br />
          <br />
          <div>
            <ion-button fill="clear" @click="showBiometricSetupModal = false"
              >Später</ion-button
            >
          </div>
          <div>
            <ion-button
              fill="clear"
              @click="
                Storage.set({
                  key: $store.state.user.UserId + '_skipBiometricSetupModal',
                  value: 'true',
                });
                showBiometricSetupModal = false;
              "
              >Nicht mehr fragen</ion-button
            >
          </div>
        </div>
      </ion-page>
    </ion-modal>

    <ion-modal
      :is-open="showNotificationSetupModal"
      :css-class="['c-autoheight-modal']"
      @didDismiss="showNotificationSetupModal = false"
    >
      <ion-page>
        <div class="ion-padding modal-content ion-text-center">
          <modal-close />
          <div class="ion-margin-bottom">
            <img width="50" src="@lib/assets/icons/notification.svg" />
          </div>
          <b>Wir schauen darauf, dass Sie alles immer im Auge behalten.</b>
          <p>
            Aktivieren Sie Benachrichtigungen, damit wir Sie an Ihre Arzttermine
            erinnern, Terminbestätigungen schicken und Sie bestmöglich
            unterstützen können, gesund zu bleiben oder schnell wieder gesund zu
            werden.
          </p>
          <ion-button fill="outline" @click="activateNotifications"
            >Aktivieren</ion-button
          >
          <br />
          <ion-button
            fill="clear"
            @click="showNotificationSetupModal = false"
            class="ion-margin-bottom"
            >Später</ion-button
          >
        </div>
      </ion-page>
    </ion-modal>

    <ion-modal
      :is-open="showRating"
      :css-class="['c-autoheight-modal']"
      @didDismiss="showRating = false"
      :backdropDismiss="false"
    >
      <ion-page>
        <div class="modal-content ion-padding ion-text-center">
          <modal-close />
          <roodie fillOuter="#5E58BE" :expression="'happy'" />
          <div v-if="ratingStep === 0">
            <h6 v-if="ratingText">{{ ratingText }}</h6>
            <h6 v-else-if="ratingVariant === 0">
              Bitte sagen Sie uns, wie zufrieden Sie mit unserem Service waren:
            </h6>
            <h6 v-else-if="ratingVariant === 1">
              Willkommen zurück! Wie ist es Ihnen seit dem Termin bei Dr. Frank
              Medicus ergangen?
            </h6>
            <h6 v-else-if="ratingVariant === 2">
              Wie zufrieden waren Sie mit der Behandlung duch Dr. Frank Medicus?
            </h6>
            <h6 v-else-if="ratingVariant === 3">
              Wie ist es Ihnen seit dem Arzttermin am {{ ratingDate }} ergangen?
            </h6>
            <h6 v-else-if="ratingVariant === 4">
              Wie zufrieden waren Sie mit dem Arztvorschlag vom
              {{ ratingDate }}?
            </h6>
            <div class="c-rating">
              <div
                class="c-rating__icon"
                :class="{ 'ion-margin-end': n < 5 }"
                v-for="n in 5"
                :key="n"
                @click="rating = n"
              >
                <smile v-if="n <= rating" />
                <smile v-else fill="white" stroke="#5E58BE" />
              </div>
            </div>
            <ion-button
              class="ion-margin-top"
              fill="outline"
              @click="modalController.dismiss()"
              >Nicht jetzt</ion-button
            >
            <ion-button
              class="ion-margin-top"
              fill="outline"
              @click="rateCase()"
              :disabled="rating === 0"
              >Abschicken</ion-button
            >
          </div>
          <div v-if="ratingStep === 1">
            <p>
              <b
                >Ihre Zufriedenheit ist uns ein besonderes Anliegen. Sagen Sie
                uns doch bitte, was wir verbessern können.</b
              >
            </p>
            <ion-textarea
              rows="3"
              v-model="ratingFeedback"
              placeholder="Ihre Meinung ist uns wichtig ..."
            ></ion-textarea>
            <ion-button
              class="ion-margin-top"
              fill="outline"
              @click="rateCase('_text')"
              :disabled="ratingFeedback === ''"
              >Weiter</ion-button
            >
          </div>
          <div v-if="ratingStep === 2">
            <p>
              <b
                >Ihre Meinung ist für uns wichtig, um unser Service laufend zu
                verbessern.
                <br />
                Vielen Dank!</b
              >
            </p>
            <ion-button
              class="ion-margin-top"
              fill="outline"
              @click="modalController.dismiss()"
              >Weiter</ion-button
            >
          </div>
        </div>
      </ion-page>
    </ion-modal>

    <ion-modal
      :is-open="showPrivacy"
      :css-class="['c-autoheight-modal']"
      @didDismiss="showPrivacy = false"
      :backdropDismiss="false"
    >
      <ion-page>
        <div class="modal-content ion-padding ion-text-center">
          <!-- <modal-close /> -->
          <roodie fillOuter="#5E58BE" :expression="'happy'" />
          <div v-html="privacy?.message"></div>
          <ion-item v-if="privacy?.checkboxLabel" lines="none">
            <ion-checkbox
              v-model="privacyAccepted"
              color="primary"
              slot="start"
            ></ion-checkbox>
            <ion-label
              class="ion-text-wrap"
              color="primary"
              style="font-size: small"
              v-html="privacy?.checkboxLabel"
            >
            </ion-label>
          </ion-item>
          <ion-button
            class="ion-margin-top"
            fill="outline"
            @click="acceptPrivacy()"
            :disabled="privacy?.checkboxLabel && !privacyAccepted"
            >{{ privacy?.buttonText }}</ion-button
          >
        </div>
      </ion-page>
    </ion-modal>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonGrid,
  IonRow,
  IonCol,
  // IonCard,
  // IonCardContent,
  // IonSelect,
  // IonSelectOption,
  IonButton,
  IonIcon,
  IonButtons,
  IonFooter,
  IonText,
  IonNote,
  IonSlides,
  IonSlide,
  IonItem,
  IonLabel,
  IonCheckbox,
  IonTextarea,
  modalController,
  // IonToggle,
  IonModal,
  onIonViewDidEnter,
  toastController,
  IonPopover,
  // IonInput,
} from "@ionic/vue";
import { ref, watch, nextTick, computed } from "vue";
import Chat from "@/components/Chat";
import {
  arrowForwardCircleOutline,
  chevronBack,
  chevronUp,
  call,
  videocam,
  hammer,
  menu,
  helpCircle,
  add,
  personAddOutline,
  cameraOutline,
  documentsOutline,
  bulbOutline,
  fingerPrintOutline,
  notificationsOutline,
} from "ionicons/icons";
// import HeartPlus from "@/components/svg/HeartPlus";
// import NextQuestionButton from "@lib/components/Questions/NextQuestionButton";
import Roodie from "@lib/components/svg/Roodie";
import Tooltip from "@lib/components/Tooltip";
import axios from "@/plugins/axios";
// import { useRouter } from "vue-router";
import { useStore } from "vuex";
import InteliwiseModal from "@/components/InteliwiseModal";
// import SpezialisierungenZTK from "@/components/SpezialisierungenZTK";
import Smile from "@/components/svg/Smile";
import { useRoute, useRouter } from "vue-router";
import { apiAddUserTag, apiGetUser, apiGetCases } from "@/api/user";
import AlertModal from "@/components/AlertModal";
import ModalClose from "@lib/components/ModalClose";
import { useGtm } from "vue-gtm";
import WelcomeScreen from "@/views/WelcomeScreen";
// import AragAppLink from "@/components/AragAppLink";
import Header from "@/components/Header";
import { isPlatform } from "@ionic/vue";
// import InteliwisePrivacyModal from "@/components/InteliwisePrivacyModal";
import { chat } from "@/mixins/chat";
import Branding from "@/components/Branding";
import { NativeBiometric, BiometryType } from "capacitor-native-biometric";
import { Capacitor } from "@capacitor/core";
import { Preferences as Storage } from "@capacitor/preferences";
// import Checkbox from "@lib/components/Questions/Checkbox";
// import ImageButtons from "@lib/components/Questions/ImageButtons"
import Buttons from "@lib/components/Questions/Buttons";
import zb from "@/utils/questions/zahnBeschwerden";
import EndModal from "@/components/EndModal";
// import InputError from "@/components/InputError";
import PartnerModal from "@/components/PartnerModal";
import AddFab from "@/components/AddFab";
import { useMessage } from "@/composables/useMessage";
import { useDoctor } from "@/composables/useDoctor";
import { DateFormatter } from "@/utils/basics/date";

export default {
  mixins: [chat],
  components: {
    IonHeader,
    IonToolbar,
    IonContent,
    IonPage,
    IonGrid,
    IonRow,
    IonCol,
    // IonCard,
    // IonCardContent,
    // IonSelect,
    // IonSelectOption,
    IonButton,
    IonIcon,
    Chat,
    IonButtons,
    IonFooter,
    // HeartPlus,
    IonText,
    IonNote,
    // NextQuestionButton,
    Roodie,
    Tooltip,
    IonSlides,
    IonSlide,
    IonItem,
    IonLabel,
    IonCheckbox,
    IonTextarea,
    // IonToggle,
    // SpezialisierungenZTK,
    IonModal,
    Smile,
    ModalClose,
    // AragAppLink,
    Header,
    Branding,
    IonPopover,
    // Checkbox,
    // ImageButtons,
    Buttons,
    // InputError,
    // IonInput,
    AddFab,
  },
  props: {
    showBiometricSetup: {
      type: String,
      required: false,
      default: "",
    },
    email: {
      type: String,
      required: false,
      default: "",
    },
    password: {
      type: String,
      required: false,
      default: "",
    },
  },
  setup() {
    const scrollElement = ref(null);
    const isPopoverOpen = ref(false);
    const popoverEvent = ref();
    const roodieCheckButton = ref(null);
    const setPopoverOpen = (state) => {
      if (roodieCheckButton.value || !state) {
        popoverEvent.value = { target: roodieCheckButton.value.$el };
        isPopoverOpen.value = state;
      }
    };
    // const showBiometricSetupModal = ref(
    //   props.showBiometricSetup === "true" ? true : false
    // );

    const showToast = async (text) => {
      const toast = await toastController.create({
        message: text,
        duration: 2000,
      });
      toast.present();
    };

    const route = useRoute();
    watch(
      () => route.params,
      (newParams) => console.log("newParams", newParams)
    );
    const isNativeBiometricAvailable = ref(false);
    const isNativeBiometricFaceId = ref(false);
    const showBiometricSetupModal = ref(false);
    const setNativeBiometricCredentials = () => {
      NativeBiometric.verifyIdentity({
        reason: "Für einfachen Login",
        title:
          (isNativeBiometricFaceId.value ? "Face ID" : "Touch ID") +
          " aktivieren",
        subtitle: "Bitte verifizieren Sie Ihre Identität",
        description: "",
        negativeButtonText: "Abbrechen",
      }).then(() => {
        // Save user's credentials
        NativeBiometric.deleteCredentials({
          server: "www.roodie-health.com",
        }).then(() => {
          NativeBiometric.setCredentials({
            username: route.params.email,
            password: route.params.password,
            server: "www.roodie-health.com",
          }).then(() => {
            Storage.set({
              key: "useBiometric",
              value: "true",
            });
            showToast(
              (isNativeBiometricFaceId.value ? "Face ID" : "Touch ID") +
                " wurde aktiviert."
            );
            showBiometricSetupModal.value = false;
          });
        });
      });
    };

    // const showRoodieCheckModal = ref(false);

    const router = useRouter();
    const store = useStore();

    const showPrivacy = ref(false);
    const privacy = ref(null);
    const privacyAccepted = ref(false);
    const todayString = new Date().toISOString().split("T")[0];
    const acceptPrivacy = async () => {
      const response = await apiAddUserTag(
        `privacy_${privacy.value?.version}_${todayString}`
      );
      if (response.data.Status === "Success") {
        showPrivacy.value = false;
      }
    };

    const showRating = ref(false);
    const rating = ref(0);
    const ratingStep = ref(0);
    const ratingVariant = ref(null);
    const ratingFeedback = ref("");
    const ratingText = ref("");
    const ratingCaseId = ref("");
    const ratingDate = ref("");
    const rateCase = async (ratingKeySuffix = "", checkExisting = false) => {
      store.commit("setShowLoading", true);
      const response = await axios.post("?Mode=General&Function=RateCase", {
        UserId: store.state.user.UserId,
        Id: ratingCaseId.value,
        Rating: ratingFeedback.value || rating.value,
        RatingKey: (ratingText.value || ratingVariant.value) + ratingKeySuffix,
        CheckExisting: checkExisting,
      });
      if (response.data.Status === "Success" && response.data.Result) {
        if (ratingStep.value === 0) {
          if (rating.value <= 2) {
            ratingStep.value = 1;
          } else {
            ratingStep.value = 2;
          }
        } else if (ratingStep.value === 1) {
          ratingStep.value = 2;
        } else {
          modalController.dismiss();
        }
      }
      return response;
    };

    const showOrthodonticsModal = ref(false);
    const showDentistIntroScreen = ref(false);
    const content = ref(null);
    const genderValue = computed(() => {
      let result = "man";
      if (store.state.user.Initials === "F") {
        result = "woman";
      } else if (store.state.user.Initials === "M") {
        result = "man";
      }
      return result;
    });
    const areatype = ref("physical");
    const person = ref("me");
    const selectedCondition = ref({});
    const paintype = ref("acute");

    const isDentist = ref(false);
    const isDentistSearch = ref(false);
    const zahnBeschwerden = ref(zb);

    const openEndModal = async (routing = "") => {
      const modal = await modalController.create({
        component: EndModal,
        componentProps: {
          routing: routing,
        },
      });
      modal.onDidDismiss().then((result) => {
        // window.location.reload();
        if (result.data?.newRouting) {
          openEndModal(result.data.newRouting);
        } else {
          store.commit("setResetHomeViewForce", true);
        }
      });
      return modal.present();
    };

    // const showPartnerModal = ref(false);
    const showPaintype = ref(false);
    const partnerModalHeadline = ref("");
    const openPartnerModal = async (eventValue) => {
      const modal = await modalController.create({
        component: PartnerModal,
        cssClass: "c-autoheight-modal",
        componentProps: {
          headline: partnerModalHeadline.value,
          bookAppointment: () => {
            modal.dismiss();
            selectedCondition.value = {
              name: "toothAppointment",
              area: "head-front",
              value: eventValue,
              type: "",
              part: "",
              deepPart: "",
            };
            showPaintype.value = false;
          },
          next: () => {
            modal.dismiss();
            openEndModal("ZTK");
          },
        },
      });
      return modal.present();
    };

    const isSpecialist = ref(false);
    const isSecondOpinion = ref(false);
    const slideOpts = {
      initialSlide: 0,
      speed: 400,
      autoplay: {
        delay: 10 * 1000,
      },
      breakpoints: {
        540: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },
        960: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
      },
    };
    const nuggetSlideOpts = {
      initialSlide: 0,
      breakpoints: {
        0: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 4.2,
          spaceBetween: 20,
        },
      },
    };
    const infoSlideOpts = {
      initialSlide: 0,
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
      },
    };
    const progress = ref(0);
    const progressChanged = ref(false);
    watch(progress, (newVal) => {
      if (newVal > 0) {
        progressChanged.value = true;
      }
    });

    const gtm = useGtm();
    const trackChatAnswer = (answerValue, questionText) => {
      gtm.trackEvent({
        // event: null, // Event type [default = 'interaction'] (Optional)
        category: "Chat - Antworten",
        action: answerValue,
        label: questionText,
        value: 1,
        // noninteraction: false, // Optional
      });
    };

    const shouldOpenInteliwiseModal = ref(false);
    const isCategory = computed(() => {
      return isSpecialist.value || isSecondOpinion.value || isDentist.value;
    });
    const fetchInteliwiseData = () => {
      // console.log("fetchInteliwiseData");
      // fetch(
      //   "https://inteliwise-eu.s3.amazonaws.com/_statuses_/prod/0b56d209329264b0d7c0141b052209010099e47e4dd912cb4110824c33ac6316.json"
      // )
      //   .then((response) => response.json())
      //   .then((data) => {
      //     if (data[-1]) {
      //       modalController
      //         .create({
      //           component: InteliwisePrivacyModal,
      //           cssClass: "c-autoheight-modal",
      //         })
      //         .then((modal) => {
      //           modal.onDidDismiss().then((data) => {
      //             if (data.data?.shouldOpenInteliwiseModal) {
      //               shouldOpenInteliwiseModal.value = true;
      //             } else {
      //               shouldOpenInteliwiseModal.value = false;
      //             }
      //           });
      //           modal.present();
      //         });
      //     }
      //   });
    };
    const openPainChat = async (name) => {
      selectedCondition.value = {
        name: name,
        area: "body-front",
        type: "pain",
        part: "",
        deepPart: "",
      };
      showPaintype.value = false;
    };
    watch(showPaintype, (newVal) => {
      if (newVal) {
        let path = "";
        let screenName = "";
        if (isSpecialist.value) {
          path = "/facharzt";
          screenName = "Facharzt/Spezialisten";
        } else if (isSecondOpinion.value) {
          path = "/zweitmeinung";
          screenName = "Zweite Meinung";
        } else if (isDentist.value) {
          path = "/zahnarzt";
          screenName = "Zahnarzt";
        } else {
          path = "/chat";
          screenName =
            "Sagen Sie uns, was Ihnen fehlt oder wo Sie Hilfe benötigen:";
        }
        if (!isCategory.value) {
          fetchInteliwiseData();
        }
        gtm.trackView(screenName, path);
      } else if (Object.keys(selectedCondition.value).length === 0) {
        gtm.trackView("Home", "/home");
      }
    });
    watch(selectedCondition, (newVal) => {
      if (
        Object.keys(newVal).length > 0 &&
        selectedCondition.value?.type !== "pain"
      ) {
        fetchInteliwiseData();
      }
    });

    const openLeaveModal = async (callback, callbackParam) => {
      const modal = await modalController.create({
        component: AlertModal,
        cssClass: "c-autoheight-modal",
        componentProps: {
          message:
            "Möchten Sie die Seite wirklich verlassen? Ihre bisher eingegebenen Daten gehen dadurch verloren.",
          buttons: ["Ja", "Nein"],
        },
      });
      modal.onDidDismiss().then((data) => {
        if (data.data?.button === "Ja") {
          progressChanged.value = false;
          callback(callbackParam);
        }
      });
      return modal.present();
    };

    const resetChatView = () => {
      selectedCondition.value = {};
      progress.value = 0;
      progressChanged.value = false;
      store.commit("setPainarea", {
        selectedMap: "",
        selectedArea: "",
        markers: [],
      });
      store.commit("setSpreadarea", {
        selectedMap: "",
        selectedArea: "",
        markers: [],
      });
      store.commit("setIsImageMapChanged", false);
    };
    const resetView = () => {
      modalController.getTop().then((modal) => {
        if (modal) {
          modalController.dismiss();
        }
      });

      showPaintype.value = false;
      isDentist.value = false;
      isDentistSearch.value = false;
      isSpecialist.value = false;
      isSecondOpinion.value = false;

      resetChatView();

      if (!showPaintype.value) {
        gtm.trackView("Home", "/home");
      }
    };
    const resetHomeView = computed(() => {
      return store.state.resetHomeView;
    });
    watch(resetHomeView, (newVal) => {
      if (newVal.value) {
        if (
          !newVal.force &&
          !showPaintype.value &&
          Object.keys(selectedCondition.value).length > 0 &&
          progress.value > 0
        ) {
          openLeaveModal(resetView);
        } else {
          resetView();
        }
        store.commit("setResetHomeViewForce", false);
      }
    });

    const showNotificationSetupModal = ref(false);
    const activateNotifications = async () => {
      store.commit("setShowLoading", true);
      const response = await apiAddUserTag("notifications-yes");
      if (response.data.Status === "Success") {
        const toast = await toastController.create({
          message: "Wir benachrichtigen Sie, sobald das Service verfügbar ist.",
          duration: 2000,
        });
        toast.present();
        showNotificationSetupModal.value = false;
      }
    };

    const { getMessages } = useMessage();
    // const { getDoctors } = useDoctor();
    // getDoctors().then(async () => {
    //   const in3Days = new Date();
    //   in3Days.setDate(in3Days.getDate() + 3);
    //   for (const appointment of store.state.doctors.appointments) {
    //     if (in3Days > appointment.nextDate) {
    //       const toast = await toastController.create({
    //         message: `Nächster Arzttermin am ${DateFormatter.formatDate(
    //           appointment.nextDate,
    //           "DD. MMMM YYYY"
    //         )}, ${appointment.Time}`,
    //         duration: 10000,
    //         cssClass: "toast-stacked",
    //         buttons: [
    //           {
    //             text: "Mehr Info",
    //             role: "info",
    //             handler: () => {
    //               router.push({ name: "termine-aerzte" });
    //             },
    //           },
    //           {
    //             text: "Ok",
    //             role: "cancel",
    //           },
    //         ],
    //       });
    //       toast.present();
    //     }
    //   }
    // });
    onIonViewDidEnter(async () => {
      console.log(route.params.email);
      console.log(route.params.password);
      console.log(route.params);

      // store.commit("setShowLoading", true);
      getMessages();
      await apiGetUser();

      const privacyResponse = await axios.get(
        "?Mode=General&Function=GetPrivacy"
      );
      if (
        privacyResponse.data.Status === "Success" &&
        privacyResponse.data.Result
      ) {
        privacy.value = privacyResponse.data.Result;
      }

      // Storage.get({ key: "showWelcomeScreen" }).then(({ value }) => {
      // if (value !== "false") {
      if (!store.state.user.Tags.includes("saw-welcome")) {
        modalController
          .create({
            component: WelcomeScreen,
            componentProps: {},
            // cssClass: "c-block-modal",
            backdropDismiss: false,
          })
          .then((welcomeScreen) => {
            welcomeScreen.onDidDismiss().then(() => {
              // showBiometricSetupModal.value = true;
              // Storage.set({
              //   key: "showWelcomeScreen",
              //   value: "false",
              // });
              apiAddUserTag("saw-welcome");
              if (privacy.value?.version) {
                apiAddUserTag(
                  `privacy_${privacy.value?.version}_${todayString}`
                );
              }
              setPopoverOpen(true);
            });
            welcomeScreen.present();
          });
      } else {
        let foundTag = false;
        for (const tag of store.state.user.Tags) {
          if (tag.startsWith(`privacy_${privacy.value?.version}`)) {
            foundTag = true;
          }
        }
        if (privacy.value?.version && !foundTag) {
          showPrivacy.value = true;
        }
      }
      // }
      // });

      console.log("route.params.from", route.params.from);
      if (
        route.params.from === "login" &&
        !store.state.user.Tags.includes("notifications-yes")
      ) {
        showNotificationSetupModal.value = true;
      }

      if (
        Capacitor.isNativePlatform() &&
        route.params.email &&
        route.params.password
      ) {
        NativeBiometric.isAvailable().then(async (result) => {
          isNativeBiometricAvailable.value = result.isAvailable;
          isNativeBiometricFaceId.value =
            result.biometryType == BiometryType.FACE_ID;
          if (isNativeBiometricAvailable.value) {
            const { value: skipBiometricSetupModal } = await Storage.get({
              key: store.state.user.UserId + "_skipBiometricSetupModal",
            });
            NativeBiometric.getCredentials({
              server: "www.roodie-health.com",
            })
              .then((credentials) => {
                console.log("NativeBiometricCredentials", credentials);
                if (
                  (credentials.username !== route.params.email ||
                    credentials.password !== route.params.password) &&
                  skipBiometricSetupModal !== "true"
                ) {
                  showBiometricSetupModal.value = true;
                }
              })
              .catch((error) => {
                console.log(error);
                // if (error.message === "No credentials found") {
                if (skipBiometricSetupModal !== "true") {
                  showBiometricSetupModal.value = true;
                }
                // }
              });
          }
        });
      }

      console.log(
        "shouldShowDentistSearch",
        route.params.shouldShowDentistSearch
      );
      if (route.params.shouldShowPaintype) {
        resetView();
        if (route.params.shouldShowPaintype === "true") {
          showPaintype.value = true;
        }
      } else if (
        route.params.shouldShowDentistSearch === "true" ||
        route.query.dentistsearch
      ) {
        resetView();
        showPaintype.value = true;
        isDentist.value = true;
        isDentistSearch.value = true;
      }

      if (route.params.name || showPaintype.value) {
        selectedCondition.value = {
          name: route.params.name,
          area: route.params.area,
          from: route.params.from,
          type: route.params.type,
          part: "",
          deepPart: "",
        };
      } else if (route.query.name && route.query.value) {
        selectedCondition.value = {
          name: route.query.name,
          area: "head-front",
          value: route.query.value,
          type: "",
          part: "",
          deepPart: "",
        };
      }

      if (route.query.rating) {
        ratingVariant.value = parseInt(route.query.rating);

        if (route.query.id) {
          ratingCaseId.value = route.query.id;
        }
        if (route.query.text) {
          ratingText.value = route.query.text;
        }
        if (route.query.date) {
          ratingDate.value = route.query.date;
        }

        await apiGetCases();
        // const foundCase = store.state.cases.find((obj) => {
        //   return obj.Id == ratingCaseId.value;
        // });
        // const foundRating = null;
        // if (foundCase) {
        //   foundRating = foundCase.Ratings?.find((obj) => {
        //     return obj.RatingKey == ratingVariant.value;
        //   });
        // }

        // if (foundRating) {
        //   const modal = await modalController.create({
        //     component: AlertModal,
        //     cssClass: "c-autoheight-modal",
        //     componentProps: {
        //       message: "Sie haben bereits eine Bewertung abgegeben.",
        //       buttons: ["Ok"],
        //     },
        //   });
        //   modal.present();
        // }

        const rateCaseResponse = await rateCase("", true);
        if (rateCaseResponse.data.Errors === false) {
          showRating.value = true;
        }
        router.replace(route.path);
      }
    });

    const livechatOnline = ref(false);
    const openInteliwiseModal = async () => {
      const modal = await modalController.create({
        component: InteliwiseModal,
      });
      return modal.present();
    };

    const needtype = ref(["treatment"]);
    watch(paintype, () => {
      const needtypeValue = needtype.value;
      needtype.value = "";
      nextTick(() => {
        needtype.value = needtypeValue;
      });
    });

    const searchtype = ref(["dentist"]);
    watch(searchtype, () => {
      if (searchtype.value.length > 1 && searchtype.value.includes("dunno")) {
        searchtype.value = ["dunno"];
      }
    });

    const nameMap = {
      pain: { checkName: "Beschwerden/Schmerzen" },
      doctorswitch: {
        checkName: "Facharzt-/Kliniksuche",
      },
      doctorsearch: {
        name: "Facharzt/&thinsp;Klinik",
        checkName: "Facharzt-/Kliniksuche",
      },
      secondopinion: {
        name: "Zweite Meinung",
        checkName: "Einholung einer Zweitmeinung",
      },

      expertsearch: "Zahnarzt in meiner Nähe",
      coaching: "Herz & Diabetes Coaching",
      toothPain: "Schmerzen/Beschwerden",
      toothSecondopinion: "Zweite Meinung einholen",
      toothDoctorsearch:
        "Ich möchte meinen Zahnarzt wechseln/suche einen Zahnarzt",
      toothCleaning: "Professionelle Zahnreinigung",
      toothCosmetic: "Kosmetische Behandlung",
      toothControl: "Kontrolltermin",
      tooth: "Zahnarzt",
      toothAppointment: "Zahnärztliche Tageskliniken",
      toothJaw: "Zahnarzt",
      toothTreatmentplan: "Prüfung meines Behandlungsplans",
      arag: "ARAG Gesund&shy;heitsassistenten",
    };
    const paintypeMap = { acute: "akute", chronic: "chronische" };
    const areatypeMap = {
      physical: "körperliche",
      mental: "psychische",
      physicalAndMental: "körperliche und psychische",
    };
    const searchtypePrefixMap = {
      acute: "brauche ein/e",
      chronic: "suche ein/e",
    };
    const searchtypeMap = {
      dentist: "Fach-/Zahnarztpraxis",
      hospital: "Klinik",
      expert: "Spezialisten für meine Krankheit/Diagnose",
      coach: "Coaching zur Verbesserung meines Gesundheitszustandes",
      dunno: "Weiß nicht genau",
    };
    const needtypeMap = {
      treatmentAcute:
        "Behandlung in einer Facharzt-/Zahnarztpraxis oder Klinik",
      treatmentChronic: "persönliche Behandlung vor Ort",
      phone: "medizinische Beratung per Telefon",
      video: "Video-Arztgespräch",
    };

    const selectedSentence = computed(() => {
      let result = "";
      if (selectedCondition.value.checkName) {
        result = selectedCondition.value.checkName;
      } else if (selectedCondition.value.value) {
        result = selectedCondition.value.value;
      } else if (selectedCondition.value.name) {
        result =
          nameMap[selectedCondition.value.name].checkName ||
          nameMap[selectedCondition.value.name].name ||
          nameMap[selectedCondition.value.name];
      }
      // else {
      //   let needtypeName = "";
      //   if (Array.isArray(needtype.value)) {
      //     let index = 0;
      //     let needtypeItem = "";
      //     for ([index, needtypeItem] of needtype.value.entries()) {
      //       if (paintype.value === "acute" && needtypeItem === "treatment") {
      //         needtypeItem = "treatmentAcute";
      //       } else if (
      //         paintype.value === "chronic" &&
      //         needtypeItem === "treatment"
      //       ) {
      //         needtypeItem = "treatmentChronic";
      //       }
      //       needtypeName += needtypeMap[needtypeItem];
      //       if (needtype.value.length - 1 > index) {
      //         needtypeName += ", ";
      //       }
      //     }
      //   } else {
      //     if (needtype.value === "treatment") {
      //       needtypeName = needtypeMap["treatmentAcute"];
      //     } else {
      //       needtypeName = needtypeMap[needtype.value];
      //     }
      //   }
      //   let searchtypeName = "";
      //   for (const [index, searchtypeItem] of searchtype.value.entries()) {
      //     searchtypeName += searchtypeMap[searchtypeItem];
      //     if (searchtype.value.length - 1 > index) {
      //       searchtypeName += ", ";
      //     }
      //   }
      //   result =
      //     "Ich habe " + paintypeMap[paintype.value] + " Beschwerden/Schmerzen";
      //   // " " +
      //   // areatypeMap[areatype.value] +
      //   // " Beschwerden und " +
      //   // searchtypePrefixMap[paintype.value] +
      //   // " " +
      //   // (paintype.value === "chronic"
      //   //     ? searchtypeName + " für eine "
      //   //     : "") +
      //   // needtypeName;
      // }
      return result;
    });

    const shouldStepBack = ref(false);
    const backToSearch = (goHome = false) => {
      if (goHome) {
        resetView();
      } else {
        if (selectedCondition.value?.type === "pain") {
          showPaintype.value = true;
        } else if (selectedCondition.value?.name?.startsWith("tooth")) {
          showPaintype.value = true;
          isDentist.value = true;
          isDentistSearch.value = true;
        } else if (selectedCondition.value?.name === "doctorsearch") {
          showPaintype.value = true;
          isSpecialist.value = true;
        } else if (selectedCondition.value?.name === "secondopinion") {
          showPaintype.value = true;
          isSecondOpinion.value = true;
        }
        resetChatView();
      }
    };
    const shouldGoBackToSearch = async (goHome = false, force = false) => {
      if (progress.value === 0 && !progressChanged.value) {
        backToSearch(goHome);
      } else if (force) {
        backToSearch(true);
      } else {
        openLeaveModal(backToSearch, goHome);
      }
    };
    const goBack = () => {
      console.log(selectedCondition.value);
      if (selectedCondition.value.from) {
        router.go(-1);
      } else if (
        showPaintype.value &&
        isDentist.value &&
        isDentistSearch.value
      ) {
        isDentistSearch.value = false;
      } else {
        shouldStepBack.value = true;
      }
    };
    const shouldGoBack = async () => {
      if (progress.value === 0 && !progressChanged.value) {
        goBack();
      } else {
        openLeaveModal(goBack);
      }
    };
    watch(shouldStepBack, (newVal) => {
      if (showPaintype.value && newVal) {
        resetView();
        shouldStepBack.value = false;
      }
    });

    // const slider = ref(null);
    // onMounted(() => {
    //   setTimeout(() => {
    //     if (slider.value) {
    //       slider.value.$el.update();
    //     }
    //   }, 1000);
    // });

    const getToolbarColor = () => {
      let color = undefined;
      if (
        !showPaintype.value &&
        Object.keys(selectedCondition.value).length === 0
      ) {
        color = "medium";
      } else if (
        Object.keys(selectedCondition.value).length > 0 ||
        (showPaintype.value && !isCategory.value) ||
        (isDentist.value && isDentistSearch.value)
      ) {
        color = "primary";
      }
      return color;
    };

    const openAragApp = () => {
      let url = "https://www.arag.de/service/kundenservice/gesundheitsapp/";
      if (isPlatform("ios")) {
        url = "https://apps.apple.com/de/app/arag-gesundheitsapp/id1230090411";
      } else if (isPlatform("android")) {
        url =
          "https://play.google.com/store/apps/details?id=com.ibm.de.ish.gesapp.arag.prod";
      }
      window.open(url, "_blank");
    };

    return {
      scrollElement,
      genderValue,
      paintype,
      areatype,
      needtype,
      searchtype,
      arrowForwardCircleOutline,
      selectedCondition,
      nameMap,
      paintypeMap,
      areatypeMap,
      searchtypePrefixMap,
      searchtypeMap,
      needtypeMap,
      selectedSentence,
      person,
      shouldStepBack,
      backToSearch,
      chevronBack,
      chevronUp,
      progress,
      progressChanged,
      call,
      videocam,
      showPaintype,
      isDentist,
      isDentistSearch,
      zahnBeschwerden,
      // showPartnerModal,
      openPartnerModal,
      partnerModalHeadline,
      openEndModal,
      isSpecialist,
      isSecondOpinion,
      slideOpts,
      nuggetSlideOpts,
      infoSlideOpts,
      // slider,
      openInteliwiseModal,
      livechatOnline,
      showDentistIntroScreen,
      content,
      showOrthodonticsModal,
      hammer,
      showBiometricSetupModal,
      // showRoodieCheckModal,
      showRating,
      modalController,
      menu,
      shouldGoBackToSearch,
      window,
      trackChatAnswer,
      helpCircle,
      isCategory,
      getToolbarColor,
      showToast,
      openAragApp,
      shouldOpenInteliwiseModal,
      openPainChat,
      shouldGoBack,
      rating,
      ratingStep,
      ratingVariant,
      ratingFeedback,
      ratingText,
      ratingDate,
      rateCase,
      add,
      personAddOutline,
      cameraOutline,
      documentsOutline,
      isPopoverOpen,
      setPopoverOpen,
      popoverEvent,
      roodieCheckButton,
      bulbOutline,
      setNativeBiometricCredentials,
      isNativeBiometricFaceId,
      fingerPrintOutline,
      showNotificationSetupModal,
      activateNotifications,
      Storage,
      notificationsOutline,
      showPrivacy,
      privacy,
      privacyAccepted,
      acceptPrivacy,
    };
  },
};
</script>

<style lang="scss">
.c-notification::part(native) {
  overflow: visible;
}

// .c-home__content {
//   --background: var(--ion-color-medium);
// }

.c-rating {
  margin-top: 40px;
  margin-bottom: 40px;
  &__icon {
    display: inline-block;
    cursor: pointer;
  }
}

.c-dashboard-box {
  background-color: var(--ion-color-medium);
  margin: -36px -16px 16px -16px;
  @media screen and (min-width: $breakpoint-lg) {
    margin: -36px -32px 16px -32px;
  }
  &__button {
    --background: white;
    --padding-top: 20px;
    --padding-bottom: 20px;
    --background-hover-opacity: 0;

    &.ion-activated .c-typewriter__text {
      color: white;
    }
  }
}

.c-progress-bar {
  height: 8px;
  border-radius: 0px 4px 4px 0px;
  background-color: var(--ion-color-primary-tint);
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  transition: all 0.5s;
}

.c-forward {
  --padding-start: 0px;
  --padding-end: 0px;
}

.c-paintype {
  --padding-start: 0px;
}

.c-dashboard {
  display: grid;
  // grid-template-rows: repeat(100px);
  // grid-template-columns: repeat(auto-fill, minmax(20em, 1fr));
  grid-template-columns: repeat(2, 1fr);
  // grid-template-rows: repeat(6, 1fr);
  // grid-template-rows: min(100px);
  // grid-template-columns: 1fr 1fr;
  @media (min-width: $breakpoint-lg) {
    grid-template-columns: repeat(4, 1fr);
  }
  gap: 20px;

  &__headline {
    grid-column: 1/-1;
    // margin: 0;
    margin-bottom: 0;
  }

  .-span {
    grid-column: 1/-1;
    height: auto;
  }
  .-half-lg {
    @media (min-width: $breakpoint-lg) {
      grid-column: auto / span 2;
      height: auto;
    }
  }
  .-quarter-lg {
    @media (min-width: $breakpoint-lg) {
      grid-column: 2 / span 1;
      height: auto;
    }
  }
}

.c-nugget-slider {
  width: 100%;
  .c-nugget {
    width: 100%;
  }
}
.c-dashboard-slider {
  height: auto;
  width: 100%;
  cursor: pointer;
  --bullet-background: var(--gangl-color-gray-3);

  .swiper-pagination {
    left: 16px;
    top: 10px;
    bottom: initial;
    width: auto;
  }
}
.c-dashboard-slide {
  text-align: left;
  background: var(--ion-color-medium);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  // background-position-x: 65%;
  width: 100%;
  border-radius: 10px;
  position: relative;
  // display: block;
  min-height: 250px;
  background-image: none !important;
  padding-top: 30px;

  &__logo {
    // padding-top: 40px;
    // padding-left: 20px;
    position: absolute;
    top: 15px;
    right: 15px;
    width: 150px;
    height: 50px;
    text-align: right;
  }

  &__content {
    width: 220px;
    padding: 20px;
    position: relative;
    font-size: 1.2rem;
    // padding-top: 60px;
    @media screen and (min-width: $breakpoint-md) and (max-width: $breakpoint-lg - 1) {
      width: 350px;
    }
  }

  &__image {
    flex-grow: 1;
    // max-height: 270px;
    padding-top: 40px;
    // padding-left: 15px;
    padding-right: 10px;
    text-align: center;
    img {
      max-height: 160px;
    }
    // @media screen and (min-width: $breakpoint-lg) {
    //   text-align: left;
    //   padding-left: 32px;
    //   padding-top: 0px;
    // }
  }

  // &:before {
  //   content: "";
  //   background: white;
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   right: 0;
  //   bottom: 0;
  //   opacity: 0.5;
  // }
}

.c-paintype {
  ion-button {
    height: auto;
    --padding-bottom: 10px;
    --padding-top: 10px;
    text-align: right;
  }
}

/* The typing effect */
@keyframes typing {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

/* The typewriter cursor effect */
@keyframes blink-caret {
  from,
  to {
    border-color: transparent;
  }
  50% {
    border-color: var(--ion-color-primary);
  }
}
</style>
